import { useLocation } from 'js/lib/useRouter';

export const useIsGenAIHub = () => {
  const currentRoute = useLocation();
  return currentRoute?.pathname?.startsWith('/explore/generative-ai');
};

export default useIsGenAIHub;
